/**
 * Shared Lexical MessageInput chrome for canvas session pane and quick chat
 * composer. The ComposerShell provides the framed surface (1.5px border +
 * rust focus ring) inside the pane card, per the design system's panel
 * variant; this config only compacts the editor for the narrow pane.
 */
export const CANVAS_SESSION_MESSAGE_INPUT_CLASSNAMES = {
  container: "w-full sm:max-w-none mx-0",
  contentWrapper: "",
  editor: "min-h-[20px] max-h-[96px] text-sm leading-5",
  placeholder: "text-sm leading-5",
} as const;
